<div *ngIf="isMobile" class="d-flex align-items-end justify-content-between mb-4">
  <a class="navbar-logo w-inline-block col-5" href="/">
    <img alt="Logo LivinFrance" class="logo" loading="lazy"
         sizes="(max-width: 479px) 66vw, 148px"
         src="/assets/img/seoHeaderImg/LF_logo-horizontal.webp"
         srcset="/assets/img/seoHeaderImg/LF_logo-horizontal-p-500.png 500w, /assets/img/seoHeaderImg/LF_logo-horizontal-p-800.png 800w, /assets/img/seoHeaderImg/LF_logo-horizontal-p-1080.png 1080w, /assets/img/seoHeaderImg/LF_logo-horizontal-p-1600.png 1600w,src\assets\img\seoHeaderImg /assets/img/seoHeaderImg/LF_logo-horizontal-p-2000.png 2000w, /assets/img/seoHeaderImg/LF_logo-horizontal.webp 2389w">
  </a>
  <button (click)="displayInfos()" class="btn m-0 border">
  <span class="title_2 d-flex flex-row gap-8 mb-0">
    {{ "PROCESSES.ACCOMMODATION.INFORMATIONS.BOOKING_INFOS.TITLE" | translate }}
    <lf-icon class="lh-1" height="16px" name="houseIcon" width="16px"></lf-icon>
  </span>
  </button>
</div>


<div *ngIf="!isMobile || isDisplay"
     [ngClass]="[isMobile ? 'modale_style m-0' : 'br-16', page == 'paiement' ? 'h-100' :'nav_padding']"
     class="box_container w-100 ">
  <h2 [ngClass]="{'pt-4': isMobile}" class="title_1 d-flex flex-row gap-8 mb-0 align-items-center">
    {{ "PROCESSES.ACCOMMODATION.INFORMATIONS.BOOKING_INFOS.TITLE" | translate }}
    <lf-icon height="24px" name="houseIcon" width="24px"></lf-icon>

    <button (click)="displayInfos()" *ngIf="isMobile" class="ms-auto btn p-0">
      <span class="material-icons-outlined">close</span>
    </button>
  </h2>
  <hr class="mb-4">
  <h3 class="title_2 mb-0">
    {{ "PROCESSES.ACCOMMODATION.INFORMATIONS.BOOKING_INFOS.DATES" | translate }}
  </h3>
  <div class="d-grid w-fit-content">
    <div class="g3 py-2 pe-2 title_3">
      {{ (booking['startDate'] ? booking['startDate'] : booking['start_date']) | date:'shortDate':'':locale }}
    </div>
    <div class="g4 d-flex align-items-center justify-content-center">
      <lf-icon height="12px" name="rarrowRight" width="12px"></lf-icon>
    </div>
    <div class="g5 py-2 px-2 title_3">
      {{ (booking['endDate'] ? booking['endDate'] : booking['end_date']) | date:'shortDate':'':locale }}
    </div>
  </div>


  <hr class="mb-4">
  <div>
    <span class="title_2">{{ room.name }}</span>
    <small class="minitext_3"> - ref {{ room.id }}</small>
  </div>
  <small class="minitext_3">{{ room.property_address.city + ' ' + room.property_address.postal_code }}</small>
  <app-item-badges [element]="room" *ngIf="room.badges"></app-item-badges>

  <div class="photo_container w-100" style="background-image:url({{room.cover_photo}})">
  </div>

  <app-accommodation-payment-details *ngIf="page != 'paiement'" [booking]="booking"
    [isAllSummaryOpen]="true"
    [isBtnDisplay]="(!isMobile && true) || (isMobile && false)"
    [selectedRoom]="room"></app-accommodation-payment-details>

  <app-need-help [contact]="agent" *ngIf="!isMobile && page != 'pending'"></app-need-help>

</div>
<div *ngIf="!isMobile" class="mt-4 mt-xl-3">
  <div class="d-flex gap-16 pb-2">
    <lf-icon height="1.5rem" name="returnMoney" width="1.5rem"></lf-icon>
    <p>{{ 'PROCESSES.ACCOMMODATION.LIST.CANCEL_BOOKING.FEES' | translate }}</p>
  </div>
  <div class="d-flex gap-16">
    <lf-icon fillColor="#00C49A" height="1.5rem" name="money" width="1.5rem"></lf-icon>
    <p>{{ 'PROCESSES.ACCOMMODATION.LIST.CANCEL_BOOKING.REFUSED_BOOKING' | translate }}</p>
  </div>
</div>
